import { Outlet } from "react-router-dom";
import { BottomNav } from "./BottomNav";

export const AppShell = () => {
  return (
    <>
      <Outlet />
      <BottomNav />
    </>
  );
};
